import React from 'react'
import MainNavigation from '@toasttab/shared/src/components/organisms/Navigation/Contentful/MainNavigation'
import { NavContextProvider } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/useNavContext'
import { getMainNavigationMenu } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/getMainNavigationMenu'
import { prependHostName } from '@toasttab/shared/src/utils/siteUtils'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useHeaderContent } from '@toasttab/shared/src/utils/layoutUtils'
import {
  NavControllerProps,
  SiteRegionTypes
} from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'

const NT_NavController = ({
  localizedEntries,
  pageHeader
}: NavControllerProps) => {
  const { headerData, packageName, region, siteId, siteMetadata } =
    usePageContext()

  // Memoize header & footer content
  const headerContent = useHeaderContent({
    headerData,
    headerOverride: { pageHeader },
    region
  })
  const siteRegion = headerContent.country.toLowerCase() as SiteRegionTypes

  const menus = headerContent?.navMenuItems
    ? [...headerContent.navMenuItems]
    : []

  // Prepend https://pos.toasttab.com for support.toasttab.com
  const navigationData =
    packageName === 'support'
      ? prependHostName(
          JSON.stringify(getMainNavigationMenu(menus, siteRegion)),
          siteMetadata.hostName
        )
      : getMainNavigationMenu(menus, siteRegion)

  const heapClasses = {
    login: `${siteRegion}_topnav_login`,
    mainNav:
      siteRegion === 'us' ? `topnav_entire_v` : `${siteRegion}_topnav_entire`,
    regionSwitcher: `${siteRegion}_topnav_region`,
    requestDemo: `${siteRegion}_topnav_demo`,
    restaurantSearch: `${siteRegion}_topnav_restaurants`
  }

  const navContext = {
    ...headerContent,
    heapClasses,
    localizedEntries,
    navigationData:
      typeof navigationData === 'string'
        ? JSON.parse(navigationData)
        : navigationData,
    siteId,
    siteRegion
  }

  return (
    <NavContextProvider value={navContext}>
      <MainNavigation />
    </NavContextProvider>
  )
}

export default NT_NavController
